import EstadoCivilService from "@/api/services/personal/nomencladores/EstadoCivilService"
import Vue from "vue"

const state = () => ({
    estados_civil: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    ESTADOS_CIVIL: state => {
        return state.estados_civil
    },
    ESTADOS_CIVIL_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_ESTADOS_CIVIL: (state, payload) => {
        state.estados_civil = payload
    },

    SET_ESTADOS_CIVIL_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ESTADO_CIVIL: (state, payload) => {
        state.estados_civil.push(payload)
    },

    UPDATE_ESTADO_CIVIL: (state, payload) => {
        state.estados_civil = state.estados_civil.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_ESTADO_CIVIL: (state, payload) => {
        state.estados_civil = state.estados_civil.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_ESTADOS_CIVIL: async ({ commit, state }, { filter, estadoCivilEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await EstadoCivilService.get({ filter, estadoCivilEstado, ...pagination })
            if (status === 200) {
                commit("SET_ESTADOS_CIVIL", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estados civil, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_ESTADOS_CIVIL: async ({ commit }) => {
        try {
            let { data, status } = await EstadoCivilService.getAll()
            if (status === 200) {
                commit("SET_ESTADOS_CIVIL", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_ESTADOS_CIVIL: async ({ commit }) => {
        try {
            let { data, status } = await EstadoCivilService.getAllRecords()
            if (status === 200) {
                commit("SET_ESTADOS_CIVIL", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estados civil, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ESTADO_CIVIL: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoCivilService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_ESTADO_CIVIL", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del estado civil, inténtelo nuevamente"
            })
        }
    },

    ADD_ESTADO_CIVIL: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoCivilService.post(payload)
            if (status === 201) {
                commit("ADD_ESTADO_CIVIL", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El estado civil ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el estado civil, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_ESTADO_CIVIL: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoCivilService.put(payload)
            if (status === 200) {
                commit("UPDATE_ESTADO_CIVIL", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El estado civil ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el estado civil, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_ESTADO_CIVIL: async ({ commit }, payload) => {
        try {
            let { status, data } = await EstadoCivilService.delete(payload)
            if (status === 204) {
                commit("DELETE_ESTADO_CIVIL", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El estado civil ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_ESTADO_CIVIL", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El estado civil ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el estado civil, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
